import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=9f054e0e&scoped=true&"
import script from "./SchoolCard.vue?vue&type=script&lang=js&"
export * from "./SchoolCard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=9f054e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f054e0e",
  null
  
)

export default component.exports